// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-group {
  height: 34px;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: white;
  text-align: center;
  white-space: nowrap;
  background-color: #36f;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.input-group-text :hover {
  color: #36f;
  background-color: white;
  border: 1px solid #36f;
}

.input-group-text.disabled {
  background-color: #ccc;
  color: #666;
  cursor: not-allowed;
  border-color: #ccc;
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 600px;
  max-width: 100%;
  table-layout: auto;
  align-items: center;
  justify-content: center;
}

.table-responsive {
  justify-content: center;
  align-items: center;
}

.custom-table thead {
  color: white;
  font-weight: 700;
  text-align: left;
  position: sticky;
  top: 0;
  z-index: 10;
  padding: 13px 10px !important;
}

th,
td {
  padding: 13px 10px !important;
  border: 1px solid #ddd;
  text-align: left;
  text-decoration: none;
}

th {
  position: sticky;
  top: 0;
  background-color: #95a2b1;
  color: white !important;
}

.headerData {
  margin-top: -25px !important;
}

.disabled-link {
  pointer-events: none;
  color: gray !important;
  text-decoration: none;
  cursor: not-allowed;
}

.navigatelink {
  color: blue;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/gamification/gamification-inquiry/gamification-inquiry.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;AACF;;AAEA;EACE,WAAA;EACA,uBAAA;EACA,sBAAA;AACF;;AAEA;EACE,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;EACA,6BAAA;AACF;;AAEA;;EAEE,6BAAA;EACA,sBAAA;EACA,gBAAA;EACA,qBAAA;AACF;;AAEA;EACE,gBAAA;EACA,MAAA;EACA,yBAAA;EACA,uBAAA;AACF;;AAEA;EACE,4BAAA;AACF;;AAEA;EACE,oBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,eAAA;AACF","sourcesContent":[".input-group {\n  height: 34px;\n}\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: white;\n  text-align: center;\n  white-space: nowrap;\n  background-color: #36f;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n}\n\n.input-group-text :hover {\n  color: #36f;\n  background-color: white;\n  border: 1px solid #36f;\n}\n\n.input-group-text.disabled {\n  background-color: #ccc;\n  color: #666;\n  cursor: not-allowed;\n  border-color: #ccc;\n}\n\n.custom-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 600px;\n  max-width: 100%;\n  table-layout: auto;\n  align-items: center;\n  justify-content: center;\n}\n\n.table-responsive {\n  justify-content: center;\n  align-items: center;\n}\n\n.custom-table thead {\n  color: white;\n  font-weight: 700;\n  text-align: left;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  padding: 13px 10px !important;\n}\n\nth,\ntd {\n  padding: 13px 10px !important;\n  border: 1px solid #ddd;\n  text-align: left;\n  text-decoration: none;\n}\n\nth {\n  position: sticky;\n  top: 0;\n  background-color: #95a2b1;\n  color: white !important;\n}\n\n.headerData {\n  margin-top: -25px !important;\n}\n\n.disabled-link {\n  pointer-events: none;\n  color: gray !important;\n  text-decoration: none;\n  cursor: not-allowed;\n}\n\n.navigatelink {\n  color: blue;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
